import React from "react";

/**
 * Full-screen app loader. Rendered as inline SVG (not an <img>) so the ring
 * can pick up the active theme's brand colour via the --primaryColor CSS
 * variable, staying in sync with whatever theme the user has selected.
 */
export const Loader: React.FC<{ label?: string }> = ({ label = "Loading..." }) => (
  <div className="csLoader" role="status" aria-label={label}>
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <style>
        {`
        @keyframes circleProgress {
          0% { stroke-dashoffset: 88; }
          45%, 55% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 88; }
        }
        @keyframes glowPulse {
          0%, 100% { opacity: 0.7; transform: scale(0.98); }
          50% { opacity: 1; transform: scale(1); }
        }
        @keyframes logoReveal {
          0%, 30% { opacity: 0; transform: scale(0.9); }
          40%, 60% { opacity: 1; transform: scale(1); }
          70%, 100% { opacity: 0; transform: scale(0.9); }
        }
        .progress-circle {
          stroke-dasharray: 88;
          animation: circleProgress 4s ease-in-out infinite;
        }
        .dollar-sign {
          animation: glowPulse 2s ease-in-out infinite;
        }
        .logo-reveal {
          animation: logoReveal 4s ease-in-out infinite;
        }
        `}
      </style>

      {/* Main Circle */}
      <circle cx="50" cy="50" r="14" fill="#FFFFFF" stroke="#E8E6EC" strokeWidth="1.5" />
      <circle
        className="progress-circle"
        cx="50"
        cy="50"
        r="14"
        fill="none"
        stroke="var(--primaryColor)"
        strokeWidth="2"
        strokeLinecap="round"
        transform="rotate(-90 50 50)"
      />

      {/* Dollar Sign in Center */}
      <text
        className="dollar-sign"
        x="50"
        y="54"
        fontFamily="Georgia, serif"
        fontSize="12"
        fill="#2C3E50"
        textAnchor="middle"
        fontWeight="bold"
      >
        $
      </text>

      {/* Small Dollar Circle Transformation */}
      <g className="logo-reveal" opacity="0">
        <circle cx="50" cy="50" r="10" fill="#FFFFFF" opacity="0.9" />
        <text
          x="50"
          y="52"
          fontFamily="Georgia, serif"
          fontSize="6"
          fill="#2C3E50"
          textAnchor="middle"
          fontWeight="bold"
        >
          $
        </text>
        <circle cx="50" cy="50" r="10" fill="none" stroke="var(--primaryColor)" strokeWidth="1" />
      </g>
    </svg>
  </div>
);

export default Loader;
